import React, { useContext, useState } from "react";
import StateContext from '../../../../../../../contexts/state-context';
import CreatableSelect from 'react-select/creatable';
import { Form } from "react-bootstrap";

const arrayPropertyItem = (props) => {

    const { setArrayElementValue } = useContext(StateContext);
    const validateValue = (value) => {
        const allErrors = {};
        let v = value;

        if (props.options !== undefined && props.options.length > 0) {
            if (!props.options.find(o => o.value === v)) {
                allErrors.invalid = "Value must be one of the predefined options.";
            }
        }
        else {
            if (props.min > 0) {
                if (initialType === "number") {
                    if (parseFloat(v) < props.min) {
                        allErrors.invalid = "Value must be greater than " + props.min + ".";
                    }
                } else {
                    if (String(v).length < props.min) {
                        allErrors.invalid =
                            "Length is shorter than the minimum length " + props.min + ".";
                    }
                }
            }

            if (Object.keys(allErrors).length === 0 && props.max > 0) {
                if (initialType === "number") {
                    if (parseFloat(v) > props.max) {
                        allErrors.invalid = "Value must be less than " + props.max + ".";
                    }
                } else {
                    if (String(v).length > props.max) {
                        allErrors.invalid =
                            "Length is longer than the maximum length " + props.max + ".";
                    }
                }
            }

            if (Object.keys(allErrors).length === 0 && props.regexp) {
                if (!String(v).match(props.regexp)) {
                    allErrors.invalid = props.invalidPatternText;
                }
            }
        }


        return allErrors;
    };

    const handleChange = (newValue) => {
        const allErrors = validateValue(newValue.value);
        setErrors(allErrors);

        if (Object.keys(allErrors).length > 0) {
            setValidated(false);
        } else {
            setValidated(true);
        }

        setArrayElementValue(
            props.group,
            props.advanced,
            props.name,
            props.index,
            newValue.value
        );
    };


    const [errors, setErrors] = useState(
        props.property !== "" ? validateValue(props.property) : {}
    );

    const [validated, setValidated] = useState(false);

    return (
        <StateContext.Consumer>
            {({ setArrayElementValue, deleteArrayElement }) => <div className='formWithButton host-input'>
                {(props.options !== undefined && props.options.length > 0) ? <CreatableSelect
                    isClearable={false}
                    classNames={{
                        control: (state) => 'form-control custom-select'
                    }}
                    onChange={(newValue) => { handleChange(newValue) }}
                    onCreateOption={(newValue) => { handleChange(newValue) }}
                    getOptionLabel={(option) => (option.label === undefined) ? option.value : option.label}
                    getOptionValue={(option) => option.value}
                    options={props.options.filter(p => !props.elements.includes(p.value))}
                    isDisabled={props.options.find(o => o.value === props.property) !== undefined && props.options.find(o => o.value === props.property).mandatory === true}
                    value={{ label: (props.options.find(o => o.value === props.property) === undefined || (props.options.find(o => o.value === props.property) !== undefined && props.options.find(o => o.value === props.property).label === undefined)) ? props.property : props.options.find(o => o.value === props.property).label, value: props.property }}
                    aria-invalid={!!errors.invalid}
                /> : <input
                    placeholder='New Value'
                    type='text'
                    className={'form-control custom-input'}
                    value={props.property || ''}
                    onChange={e => { handleChange(e.target) }}
                    isInvalid={!!errors.invalid}
                />}
                {(props.options === undefined || props.options.length === 0 || props.options.find(o => o.value === props.property) === undefined || props.options.find(o => o.value === props.property).mandatory !== true) ?
                    <button className='unmask'
                        title={`Delete '${props.property !== undefined ? props.property : 'empty'}' entry`}
                        onClick={e => {
                            deleteArrayElement(props.group, props.advanced, props.name, props.index);
                        }}
                    >
                        <i className='far far fa-trash-alt text-danger' aria-hidden='true'></i>
                    </button>
                : null}
                {errors.invalid && (
                    <div className="form-text text-danger small">
                        {errors.invalid}
                    </div>
                )}
            </div>}
        </StateContext.Consumer>
        
    );
}

export default arrayPropertyItem;
